// src/components/AboutUsContent.js
import React from 'react';
import { Link } from 'react-router-dom';

import './AboutUs.css';
import IMAGE_DEITY from '../images/deity_murti.png';
import IMAGE_INTERIOR from '../images/temple_interior.png';

const AboutUsContent = () => {
    return (
        <>
            {/* 1. Hero Header Section */}
            <div className="story-hero-header">
                <h1 className="story-hero-title">Our Story</h1>
            </div>

            {/* 2. Main Narrative & Image Blocks */}
            <section className="story-content-section">
                <div className="content-wrapper">
                    
                    {/* Primary Heading/Subtitle */}
                    <h2 className="section-heading-primary">
                        Connecting Devotees with <span>Sacred Spaces</span>
                    </h2>
                    <p className="section-subtitle-primary">
                        eMANTRA was born from a deep, heartfelt desire for Hindu traditions and a desire to make spiritual practices more accessible. We bridge the gap, allowing devotees to connect with sacred spaces and participate in Pujas from anywhere in the world.
                    </p>
                    
                    {/* Mission Block (Text Left, Image Right) */}
                    <div className="story-block">
                        <div className="story-text-column">
                            <h2>Our Mission</h2>
                            <p>
                                Our mission is to facilitate a seamless and authentic spiritual experience. We strive to ensure every Puja is performed with utmost devotion and adherence to traditional rituals, bringing the divine blessings of the temples directly to your home.
                            </p>
                        </div>
                        <div className="story-image-column">
                            <img src={IMAGE_DEITY} alt="Deity Murti" />
                        </div>
                    </div>

                    {/* Transparency Block (Image Left, Text Right - using reverse) */}
                    <div className="story-block reverse">
                        <div className="story-text-column">
                            <h2>Transparency and Trust</h2>
                            <p>
                                We value transparency above all. We are an independent platform, not official representatives of any temple. We ensure that every ritual performed is documented and conducted with the highest standards of authenticity, acting as a bridge to connect you with them.
                            </p>
                        </div>
                        <div className="story-image-column">
                            <img src={IMAGE_INTERIOR} alt="Temple Interior" />
                        </div>
                    </div>

                </div>
            </section>

            {/* 3. Join Us CTA Section */}
            <section className="story-cta">
                <h2>Join Us on This Spiritual Journey</h2>
                <p>
                    We invite you to experience the divine blessings from the comfort of your home. Whether you seek to perform an Archana, a special Puja, or simply connect with your faith, eMANTRA is here to support you.
                </p>
                <Link to="/services" className="btn-explore">Explore Our Services</Link>
            </section>
        </>
    );
};

export default AboutUsContent;
